import GoFetch from '~/js/modules/fetch-wrapper';
import Spinner from '~/js/components/general/Spinner';
import MainView from '~/js/components/liv-plus/MainView';
import DetailsView from '~/js/components/liv-plus/DetailsView';
import categoriesData from '~/js/components/liv-plus/data/categories';
// import eventsDataMocks from '~/js/components/liv-plus/data/events';

const { PureComponent } = React;

const fetch = new GoFetch();

class LivPlusContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      eventsData: [],
      isEventsLoading: true
    };
  }

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate() {
    if (this.state.eventDetails) {
      window.addEventListener('popstate', this.backClickedHandler);
    } else {
      window.removeEventListener('popstate', this.backClickedHandler);
    }
  }

  getData = () => {
      Promise.all([
            fetch.post('/events/fetchLivPlus/'),
            fetch.post('/fetchSandalsAndBeachesResorts/')])
            .then(([eventsResponse, resortsResponse]) => { 
              
            const eventId = this.getQueryParams('eventId');
            let resortsData = resortsResponse.data.resorts;

            let beachesResorts = resortsData.filter(resort=> resort.brand.toLowerCase() === 'b');
            let sandalsResorts = resortsData.filter(resort=> resort.brand.toLowerCase() === 's');

            let { events } = eventsResponse.data;

        // events = events.filter(event => event.eventId !== 10237);

        const processedData = events.reduce((eventAccum, currentEvent ) => {
          const eventObj = currentEvent;
          const isBeachesResort = eventObj.brand.toLowerCase() === 'b';
          const resortListLength = eventObj.resortCodeList.length;

          if (isBeachesResort) {
 
            if (resortListLength === beachesResorts.length) {
              eventObj.resortInfo = 'All Beaches Resorts';
            }
            if (resortListLength > 1 && resortListLength < beachesResorts.length) {
              eventObj.resortInfo = 'At Selected Beaches Resorts';
            }
          } else {
            if (resortListLength === sandalsResorts.length) {
              eventObj.resortInfo = 'All Sandals Resorts';
            }
            if (resortListLength > 1 && resortListLength < sandalsResorts.length) {
              eventObj.resortInfo = 'All Sandals Resorts';
              // At Selected Sandals Resorts
            }
          }

          return [...eventAccum, eventObj];
        }, []);

        this.setState({
          eventDetails: eventId && processedData.filter(el => el.eventId === +eventId)[0],
          eventsData: events.filter(el => el),
          isEventsLoading: false
        });
      })
      .catch(() => {
        this.setState({ eventsData: [], isEventsLoading: false });
      });
  }

  learMoreHandler = (event) => {
    this.prevTopScroll = window.scrollY;
    this.setQueryParams(event.eventId, 'eventId');

    window.scrollTo(0, 0);

    this.setState({ eventDetails: event });
  }

  setQueryParams = (value, key = 'section') => {
    const state = { [key]: value };

    let uri = window.location.pathname;

    if (value) {
      uri = `?${$.param(state)}`;
    }

    window.history.pushState(state, null, uri);
  }

  getQueryParams = (name) => {
    const results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);

    return results && (results[1] || null);
  }

  tabHandler = (tab) => {
    if (tab.type === 'all') {
      this.setState({ tabChecked: null }, this.setQueryParams(null));
    } else {
      this.setState({ tabChecked: tab }, this.setQueryParams(tab.type));
    }
  }

  backClickedHandler = () => {
    this.setState({ eventDetails: null });

    if (this.state.tabChecked) {
      this.setQueryParams(this.state.tabChecked.type);
    } else {
      this.setQueryParams(null);
    }
  }

  scrollToPrevItem = () => {
    this.prevTopScroll && window.scrollTo(0, this.prevTopScroll);
  }

  setDefaultSection = () => {
    const section = this.getQueryParams('section');

    if (section) {
      const currentCategory = categoriesData.find((el) => el.type === section);

      currentCategory && this.setState({ tabChecked: currentCategory });
    }
  }

  renderView = () => {
    const { eventsData, eventDetails, tabChecked, isEventsLoading } = this.state;
    const eventId = this.getQueryParams('eventId');

    let filtredEventsData = eventsData;

    if (tabChecked) {
      filtredEventsData = eventsData.filter((el) => el.groupName.toLowerCase() === tabChecked.type);
    }

    let view = (
      <MainView
        events={filtredEventsData}
        tabChecked={tabChecked}
        loading={isEventsLoading}
        tabHandler={this.tabHandler}
        learMoreHandler={this.learMoreHandler}
        initialTopScroll={this.scrollToPrevItem}
        setDefaultSection={this.setDefaultSection} />
    );

    if (eventId) {
      view = <Spinner />;
    }

    if (eventDetails) {
      view = <DetailsView data={eventDetails} onBackClicked={this.backClickedHandler} />;
    }

    return view;
  }

  render() {
    return this.renderView();
  }
}

export default LivPlusContainer;
